function Moldova({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1658)">
  <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5069 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5069 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#FFDA44"/>
  <path d="M9.0435 1.58789C3.69163 4.17583 0 9.65639 0 15.9997C0 22.343 3.69163 27.8236 9.0435 30.4115V1.58789Z" fill="#0052B4"/>
  <path d="M22.9565 1.58789V30.4115C28.3084 27.8236 32 22.343 32 15.9997C32 9.65639 28.3084 4.17583 22.9565 1.58789Z" fill="#D80027"/>
  <path d="M21.5652 12.5887H17.7391C17.7391 11.6282 16.9605 10.8496 16 10.8496C15.0395 10.8496 14.2609 11.6282 14.2609 12.5887H10.4348C10.4348 13.5344 11.2586 14.301 12.2042 14.301H12.1472C12.1472 15.2467 12.9138 16.0134 13.8596 16.0134C13.8596 16.8507 14.4609 17.5465 15.2552 17.6952L13.9058 20.7416C14.5524 21.0044 15.259 21.1505 16 21.1505C16.7409 21.1505 17.4476 21.0044 18.0941 20.7416L16.7448 17.6952C17.5391 17.5465 18.1404 16.8507 18.1404 16.0134C19.0862 16.0134 19.8528 15.2467 19.8528 14.301H19.7958C20.7414 14.301 21.5652 13.5344 21.5652 12.5887Z" fill="#FF9811"/>
  <path d="M16 14.9561L13.7391 15.9996V18.0865L16 19.4778L18.2609 18.0865V15.9996L16 14.9561Z" fill="#0052B4"/>
  <path d="M13.7391 13.9131H18.2609V16H13.7391V13.9131Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Moldova;
